import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

type AlertType = 'success' | 'error' | 'warning' | 'info';

interface AlertProps {
  type?: AlertType;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({ 
  type = 'info', 
  title, 
  children, 
  className = '' 
}) => {
  const styles = {
    success: {
      container: 'bg-green-50 border-green-200 text-green-800',
      icon: <CheckCircle className="w-5 h-5 text-green-600" />
    },
    error: {
      container: 'bg-red-50 border-red-200 text-red-800',
      icon: <AlertCircle className="w-5 h-5 text-red-600" />
    },
    warning: {
      container: 'bg-orange-50 border-orange-200 text-orange-800',
      icon: <AlertTriangle className="w-5 h-5 text-orange-600" />
    },
    info: {
      container: 'bg-blue-50 border-blue-200 text-blue-800',
      icon: <Info className="w-5 h-5 text-blue-600" />
    }
  };

  const currentStyle = styles[type];

  return (
    <div className={`p-4 rounded-xl border flex items-start gap-3 ${currentStyle.container} ${className}`}>
      <div className="shrink-0 mt-0.5">
        {currentStyle.icon}
      </div>
      <div className="flex-1">
        {title && <h5 className="font-bold mb-1 text-sm">{title}</h5>}
        <div className="text-sm opacity-90">
          {children}
        </div>
      </div>
    </div>
  );
};